export const ResendWelcomeEmailFormName = 'resend-email-email';

export enum ResendWelcomeEmailFormFields {
  emailAddress = 'emailAddress',
}
